import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["track", "slide", "tab", "progress", "counter"]

  connect() {
    this.index = 0
    this.locked = false
    this.resetting = false
    this.count = this.slideTargets.length
    this.onWheel = this.onWheel.bind(this)

    this.element.addEventListener("wheel", this.onWheel, { passive: false })
    this.go(0)
  }

  disconnect() {
    this.element.removeEventListener("wheel", this.onWheel)
    clearTimeout(this.lockTimer)
    clearTimeout(this.resetTimer)
  }

  next() {
    if (this.index === this.count - 1) {
      this.softReset(0)
      return
    }

    this.go(this.index + 1)
  }

  prev() {
    if (this.index === 0) {
      this.softReset(this.count - 1)
      return
    }

    this.go(this.index - 1)
  }

  jump(event) {
    this.go(Number(event.currentTarget.dataset.serviceScrollIndexParam))
  }

  onWheel(event) {
    const movement = Math.abs(event.deltaY) >= Math.abs(event.deltaX) ? event.deltaY : event.deltaX
    if (Math.abs(movement) < 36 || this.locked || this.resetting) return

    event.preventDefault()
    movement > 0 ? this.next() : this.prev()
    this.lock()
  }

  lock() {
    this.locked = true
    clearTimeout(this.lockTimer)
    this.lockTimer = setTimeout(() => {
      this.locked = false
    }, 1150)
  }

  go(index) {
    if (!this.count) return

    this.index = (index + this.count) % this.count
    this.trackTarget.style.transform = `translateX(-${this.index * 100}%)`

    this.slideTargets.forEach((slide, idx) => {
      const active = idx === this.index
      slide.classList.toggle("service-carousel-slide-active", active)
      slide.classList.toggle("service-carousel-slide-muted", !active)
    })

    this.tabTargets.forEach((tab, idx) => {
      const active = idx === this.index
      tab.classList.toggle("bg-brand-700", active)
      tab.classList.toggle("text-white", active)
      tab.classList.toggle("shadow-md", active)
      tab.classList.toggle("bg-white/40", !active)
      tab.classList.toggle("text-white/70", !active)
    })

    if (this.hasProgressTarget) {
      this.progressTarget.style.width = `${((this.index + 1) / this.count) * 100}%`
    }

    if (this.hasCounterTarget) {
      this.counterTarget.textContent = `${String(this.index + 1).padStart(2, "0")} / ${String(this.count).padStart(2, "0")}`
    }
  }

  softReset(index) {
    if (!this.count || this.resetting) return

    this.resetting = true
    this.locked = true
    this.trackTarget.classList.add("opacity-0", "scale-[0.985]")

    clearTimeout(this.resetTimer)
    this.resetTimer = setTimeout(() => {
      const previousTransition = this.trackTarget.style.transition
      this.trackTarget.style.transition = "none"
      this.go(index)

      requestAnimationFrame(() => {
        this.trackTarget.style.transition = previousTransition
        this.trackTarget.classList.remove("opacity-0", "scale-[0.985]")

        this.resetTimer = setTimeout(() => {
          this.resetting = false
          this.locked = false
        }, 600)
      })
    }, 260)
  }
}
